import InsightTower from '../components/modules/insight-tower';

const InsightTowerRoute = [
  {
    path: '/insight-tower',
    name: 'InsightTower',
    component: InsightTower,
    meta: {
      title: 'InsightTower',
    },
  },
];

export default InsightTowerRoute;
